export enum InputTypeEnum {
    Text,
    Number,
    Percentage,
    Currency,
    MultiLine,
    DateOnly,
    DateTime,
    YesNo,
    hyperLink,
    picture,
    choice,
    multiChoice,
    peoplePickerSingle,
    peoplePickerMultiple,
    taxonomySingle,
    taxonomyDouble,
    datasourceText,
    datasourceDropdown,
    datasourceMultipleDropdown,
    lookupMulti,
    lookupSingle,
    datasourceTagPicker
}